<template>
  <div class="skeleton-container" :style="containerStyle">
    <!-- 文章列表骨架 -->
    <div 
      v-for="i in rowCount" 
      :key="i"
      class="article-item"
      :style="itemStyle"
    >
      <!-- 头像区域 -->
      <div 
        v-if="showAvatar"
        class="avatar"
        :style="{
          width: avatarSize + 'px',
          height: avatarSize + 'px',
          marginRight: gutter + 'px'
        }"
      ></div>
      
      <!-- 内容区域 -->
      <div class="content">
        <!-- 标题 -->
        <div 
          class="title-line" 
          :style="{ 
            width: titleWidth,
            height: lineHeight + 'px'
          }"
        ></div>
        
        <!-- 元数据 -->
        <div 
          v-if="showMeta"
          class="meta-line"
          :style="{ 
            width: metaWidth,
            height: lineHeight + 'px'
          }"
        ></div>
        
        <!-- 内容行（可配置行数） -->
        <div 
          v-for="line in lines"
          :key="line"
          class="content-line"
          :style="{ 
            width: getLineWidth(line),
            height: lineHeight + 'px'
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListSkeleton',
  props: {
    // 行数配置
    rowCount: {
      type: Number,
      default: 5
    },
    // 是否显示头像
    showAvatar: {
      type: Boolean,
      default: true
    },
    // 头像尺寸
    avatarSize: {
      type: Number,
      default: 48
    },
    // 间距
    gutter: {
      type: Number,
      default: 16
    },
    // 标题宽度
    titleWidth: {
      type: String,
      default: '60%'
    },
    // 是否显示元数据
    showMeta: {
      type: Boolean,
      default: true
    },
    // 元数据宽度
    metaWidth: {
      type: String,
      default: '40%'
    },
    // 内容行数
    lines: {
      type: Number,
      default: 3
    },
    // 随机行宽
    randomWidth: {
      type: Boolean,
      default: true
    },
    // 行高
    lineHeight: {
      type: Number,
      default: 16
    },
    // 是否启用动画
    animated: {
      type: Boolean,
      default: true
    },
    // 动画速度（秒）
    animationSpeed: {
      type: Number,
      default: 1.5
    },
    // 容器样式
    containerStyle: {
      type: Object,
      default: () => ({ padding: '0 20px 20px' })
    },
    // 项目样式
    itemStyle: {
      type: Object,
      default: () => ({ padding: '20px 0 12px' })
    }
  },
  methods: {
    getLineWidth(line) {
      if (!this.randomWidth) return '100%'
      // 生成随机宽度（70%-100%）
      return `${70 + Math.floor(Math.random() * 31)}%`
    }
  }
}
</script>

<style lang="scss" scoped>
.skeleton-container {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
}

.article-item {
  display: flex;
  border-bottom: 1px solid #f0f0f0;

  .avatar {
    background: #f2f2f2;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .content {
    flex: 1;
    
    .title-line,
    .meta-line,
    .content-line {
      background: #f2f2f2;
      border-radius: 4px;
      margin-bottom: 12px;

      @at-root .animated & {
        animation: skeleton-animation v-bind(animationSpeed + 's') ease-in-out infinite;
      }
    }

    .meta-line {
      margin-top: 8px;
    }
  }
}

@keyframes skeleton-animation {
  0% { opacity: 0.6 }
  50% { opacity: 1 }
  100% { opacity: 0.6 }
}
</style>